<template>
  <v-app>
    <Header></Header>
    <v-main>
      <transition name="kefuri">
        <router-view> </router-view>
      </transition>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';

export default {
  name: 'App',

  components: {
    Header, Footer
  },

  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
  @font-face {
    font-family: 'Nunito';
    src: url('./sass/font/Nunito-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Nunito Bold';
    src: url('./sass/font/Nunito-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @import "./sass/variables";

.kefuri-enter-active,
.kefuri-leave-active {
  transition: opacity 0.5s ;
}
.kefuri-enter,
.kefuri-leave-to {
  opacity: 0;
}
</style>
